export default __webpack_public_path__ + "static/cruiselines-vrc-ship-1-aaf89c5649a0142acff2378ea935b090.jpg";